// extracted by mini-css-extract-plugin
export default {"labelWrapper":"LabeledInput_labelWrapper__o+f0T","inputStyle":"LabeledInput_inputStyle__fZwL+"};